import { render, staticRenderFns } from "./ModalCreditIsOver.vue?vue&type=template&id=85c2b194"
import script from "./ModalCreditIsOver.vue?vue&type=script&lang=ts"
export * from "./ModalCreditIsOver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports